import React, { Component } from "react";
import styled from "styled-components";
import { SectionTitle, InnerContent } from "../../../pages/Ems/Main";

class EnergyStatus extends Component {
  render() {
    return (
      <>
        <SectionTitle>에너지 상태 모니터링</SectionTitle>
        <InnerContent>
          <ImageBox>
            <p>이미지 삽입</p>
          </ImageBox>
        </InnerContent>
      </>
    );
  }
}

const ImageBox = styled.div`
  position: relative;
  height: 370px;
  p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
export default EnergyStatus;
